import { r as registerInstance, h } from './index-5faac9d7.js';
import { b as productCtas, a4 as RANGE, ae as CAASContentOverviewSlotName } from './currency-7be6806c.js';
import { r as requestRangeSelectorConfig } from './helper-6fbc871e.js';
import { u as updateProductCtasSelectorSettings } from './product-selector-utils-94175aab.js';
import { T as TAB_NAMES } from './constants-74678075.js';
import { a as getFilteredBreadcrumbs } from './utils-5c7c3926.js';
import './product-card-c5e7a62c.js';
import { s as store } from './pes-router-store-0c1092be.js';
import './store-22db8dad.js';
import './index-e29b327a.js';
import './analytics-b6a65ffa.js';
import './analytics-205f1857.js';
import './number-57a50dcb.js';
import './helpers-e12aa36b.js';
import './constants-7d3b1dc0.js';
import './checkoutEventEmitter.service-41cc6ce1.js';
import './_basePickBy-e4f30088.js';
import './_arrayLikeKeys-728b0edd.js';
import './isEmpty-51908328.js';
import './_nodeUtil-f95b2b52.js';
import './_commonjsHelpers-11ca3be1.js';
import './isSymbol-bae590b5.js';
import './_Stack-68736bd1.js';
import './toString-10b0f228.js';
import './_isIndex-3036d479.js';
import './keysIn-6ff99c07.js';
import './hasIn-53d8ae96.js';
import './_flatRest-cb1a737b.js';
import './_baseFlatten-65704796.js';
import './index-5d9a618b.js';
import './pes-product-link-74e48119.js';
import './utils-5735b62e.js';
import './helpers-c4d5ad02.js';
import './tslib.es6-613ce1cd.js';
import './__node-resolve_empty-7dfe5913.js';
import './toNumber-6e3a0b09.js';
import './index-e233ecdd.js';
import './cta-list-298471fe.js';
import './_baseFor-a28737de.js';
import './_copyObject-8b49fce6.js';
import './utils-6c8f178b.js';
import './index-54dd34b7.js';
import './lodash-bd96d09c.js';

const PBS_BACKGROUND_COLOR = '#FFF';

const ProductAppRange = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.productCtasState = this.productCtas;
    this.productSelector = null;
    this.SE_BRAND = 'se';
    this.requestRangeSelectorConfigCreator = () => requestRangeSelectorConfig(this.host, this.rangeId, {
      countryCode: this.countryCode,
      languageCode: this.languageCode,
      brand: this.SE_BRAND,
    });
    this.host = undefined;
    this.endpoint = undefined;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.rangeId = undefined;
    this.showBreadcrumbs = undefined;
    this.showDocuments = undefined;
    this.productCtas = productCtas;
    this.showBuyOnline = undefined;
    this.siteType = undefined;
    this.mainInfo = undefined;
    this.tabs = undefined;
    this.recentlyViewedProducts = undefined;
    this.metaTags = undefined;
    this.isTabsInitialized = false;
    this.isLoading = false;
    this.documentsTabEnabled = {
      [TAB_NAMES.Documents]: false,
      [TAB_NAMES.Software]: false,
    };
    this.documentListing = undefined;
    this.hostWithLocale = '';
  }
  productCtasDidChange(newProductCtas) {
    this.selectorExtraOptions = updateProductCtasSelectorSettings(this.productSelector, this.productCtas.buttons);
    this.productCtasState = Object.assign({}, newProductCtas);
  }
  get customBreadcrumbs() {
    var _a;
    if (!this.showBreadcrumbs) {
      return null;
    }
    return getFilteredBreadcrumbs((_a = this.mainInfo) === null || _a === void 0 ? void 0 : _a.breadcrumbs);
  }
  getRichText(content) {
    const { richText } = content;
    const richTextResponse = richText || content.MainContent[0].richText;
    return richTextResponse === null || richTextResponse === void 0 ? void 0 : richTextResponse.map((item) => item.replace(/<p>|&nbsp;|&#160;|<\/p>/g, '').trim());
  }
  componentWillRender() {
    store.set('enableAppRouting', true);
  }
  componentWillLoad() {
    this.hostWithLocale = `${this.host}${this.countryCode}/${this.languageCode}/`;
  }
  render() {
    const { image, name, description, masterRangeName, longDescription, rangePartofLabel, } = this.mainInfo;
    const { analyticsPageData } = this.metaTags;
    return (h("se-container", { display: "block", style: {
        'background-color': PBS_BACKGROUND_COLOR,
      } }, this.showBreadcrumbs && (h("pes-breadcrumbs", { breadcrumbs: this.customBreadcrumbs, hideOnMobile: false, class: "pes-app-pdp__section pes-app-pdp__section--breadcrumbs", hostWithLocale: this.hostWithLocale })), h("pes-range-main", { host: this.host, endpoint: this.endpoint, rangePartofLabel: rangePartofLabel, commercialStatus: this.mainInfo.commercialStatus, description: description, image: image, longDescription: longDescription, masterRangeName: masterRangeName, name: name, brandLogo: this.mainInfo.brandLogo, id: this.mainInfo.id, localeCode: `${this.countryCode.toUpperCase()}/${this.languageCode}`, rangeCtas: this.mainInfo.rangeCtas, requestRangeSelectorConfig: this.requestRangeSelectorConfigCreator, readMoreLabel: this.mainInfo.readMoreLabel, readLessLabel: this.mainInfo.readLessLabel, learnMoreLabel: this.mainInfo.learnMoreLabel, moreOptionsLabel: this.mainInfo.moreOptionsLabel, rangeType: this.mainInfo.rangeType }), this.tabs.tabs && (h("pes-spryker-range-tabs", { tabs: this.tabs.tabs, hostWithLocale: this.hostWithLocale, appProductsLabel: this.mainInfo.appProductsLabel, commonFiltersFilterBy: this.mainInfo.commonFiltersFilterBy, facetButtonResetAllLabel: this.mainInfo.facetButtonResetAllLabel, facetButtonViewLessFilters: this.mainInfo.facetButtonViewLessFilters, facetButtonViewMoreFilters: this.mainInfo.facetButtonViewMoreFilters, nextLabel: this.mainInfo.nextLabel, pageLabel: this.tabs.pageLabel, noResultsClearLink: this.mainInfo.noResultsClearLink, noResultsHeader: this.mainInfo.noResultsHeader, noResultsMessage: this.mainInfo.noResultsMessage, numberProductsOfAllProductsLabel: this.mainInfo.numberProductsOfAllProductsLabel, previousLabel: this.mainInfo.previousLabel, rangeProductLabel: this.mainInfo.rangeProductLabel, rangeProductsFiltersLabel: this.mainInfo.rangeProductsFiltersLabel, viewLessLabel: this.mainInfo.viewLessLabel, viewMoreLabel: this.mainInfo.viewMoreLabel, viewProductsLabel: this.mainInfo.viewProductsLabel, rangePresentationLabel: this.mainInfo.rangePresentationLabel, loadMoreLabel: this.tabs.loadMoreLabel, loadPreviousLabel: this.tabs.loadPreviousLabel, backLabel: this.mainInfo.backLabel, localeCode: `/${this.countryCode}/${this.languageCode}`, rangeReference: this.mainInfo.rangeReference, host: this.host, endpoint: this.endpoint, rangeSoftwareAndFirmwareLabel: this.tabs.rangeSoftwareAndFirmwareLabel, rangeWebinarsAndResourcesLabel: this.tabs.rangeWebinarsAndResourcesLabel, softwareRegistrationLabel: this.tabs.softwareRegistrationLabel, descriptionBigger: this.mainInfo.descriptionBigger, id: this.mainInfo.id, name: name, navigationState: this.mainInfo.navigationState, showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, productCtas: this.productCtasState, isPBS: true, documentListing: this.documentListing, analyticsPageData: analyticsPageData }, h("slot", { slot: CAASContentOverviewSlotName, name: CAASContentOverviewSlotName }))), h("pes-products-carousel", Object.assign({}, this.recentlyViewedProducts, { isBackgroundGrey: true, class: "pes-app-range__section", hostWithLocale: this.host, pageId: this.rangeId, pageType: RANGE }))));
  }
  static get watchers() { return {
    "productCtas": ["productCtasDidChange"]
  }; }
};

export { ProductAppRange as pes_app_spryker_range };
